export default __webpack_public_path__ + "static/media/Sage's Breastplate of the Three Clarities.6fdcdedc.jpg";